import { resolveVariantFromProps } from './basler-components.es875.js';

function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, props.custom, visualElement);
}

export { resolveVariant };
